import { styled as c, Box as x } from "@mui/material";
import { useFrontendConfigContext as j } from "../../config-lib/contexts/FrontendConfigContext.js";
import "../../config-lib/deserializes/yup/config.js";
import "../../config-lib/graphql/getFrontendConfig.js";
import "@apollo/client";
import "../../apostle-lib/deserializes/yup/apostle.js";
import { useCallback as w, useMemo as p, useEffect as H } from "react";
import * as e from "ramda";
import "../../temp-lib/util/i18n/helper/locale.js";
import { useTranslation as S } from "react-i18next";
import { useAccountContext as b } from "../../temp-lib/contexts/account/AccountContext.js";
import u from "./TokenSection.js";
import { useRouter as y } from "next/router";
import { jsxs as A, jsx as m } from "react/jsx-runtime";
const E = c(x)`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: flex-start;
`, N = c(u)`
  .Custom-Title {
    color: #6eeae6;
  }
`, O = c(u)`
  .Custom-Title {
    color: #90ffd5;
  }
`, P = (l) => {
  const {
    className: f
  } = l, {
    pathname: k
  } = y(), {
    account: o,
    fetchBalances: T
  } = b(), {
    config: t
  } = j(), {
    t: i
  } = S(), s = w((n, h) => e.pipe(e.map((r) => e.find((a) => (a == null ? void 0 : a.assetName) === r, Object.values(h.balances || {}))), e.reject(e.isNil), e.reject((r) => r.amount === "0"))(n), []), d = p(() => {
    const n = (t == null ? void 0 : t.supportToken.accountHeaderTokens.offChain) || [];
    return s(n, o);
  }, [o, t == null ? void 0 : t.supportToken.accountHeaderTokens.offChain, s]), C = p(() => {
    const n = (t == null ? void 0 : t.supportToken.accountHeaderTokens.onChain) || [];
    return s(n, o);
  }, [o, t == null ? void 0 : t.supportToken.accountHeaderTokens.onChain, s]);
  return H(() => {
    o.walletAddress && T();
  }, [o.walletAddress, k]), /* @__PURE__ */ A(E, {
    className: f,
    children: [/* @__PURE__ */ m(O, {
      title: i("currency_group.onchain"),
      tokens: C
    }), /* @__PURE__ */ m(N, {
      title: i("currency_group.offchain"),
      tokens: d
    })]
  });
};
export {
  P as default
};
//# sourceMappingURL=TokenSectionDesktop.js.map
